import type { ReactNode } from "react";

import { useUserAreaBoundary } from "components/UserAreaBoundary/useUserAreaBoundary";
import type { UserAreaName } from "types/user.types";

type Props = {
    areas: UserAreaName[];
    children: ReactNode;
    fallback?: ReactNode;
    allowDeveloperMode?: boolean;
};

const UserAreaBoundary = (props: Props) => {
    const { areas, children, allowDeveloperMode = false, fallback = null } = props;

    const { isAllowed } = useUserAreaBoundary({ areas, allowDeveloperMode });

    if (!isAllowed) {
        return fallback;
    }

    return children;
};

export { UserAreaBoundary };
